// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-bar[data-v-69270623] {\n    background-color: var(--white-color);\n}\n", ""]);
// Exports
module.exports = exports;
